module.exports = __webpack_public_path__ + "img/cowise4.c0c5a50e.png";